import { defineComponent as o, createBlock as n, openBlock as l, unref as d, mergeProps as p, withCtx as i, createElementVNode as t } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const h = /* @__PURE__ */ o({
  name: "IconCreditCard",
  __name: "IconCreditCard",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const a = r;
    return (v, e) => (l(), n(d(m), p(a, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        t("path", { d: "M5.25 15A.75.75 0 0 1 6 14.25h4a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 15M13 14.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1" }, null, -1),
        t("path", {
          "fill-rule": "evenodd",
          d: "M4.5 5.25A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25h15a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-15M3.75 7.5A.75.75 0 0 1 4.5 6.75h15a.75.75 0 0 1 .75.75v1H3.75v-1m0 4v5a.75.75 0 0 0 .75.75h15a.75.75 0 0 0 .75-.75v-5H3.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  h as default
};
